import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,
  token: null,
  login: () => {},
  logout: () => {},
  name: "",
  type: "",
  // ["male","female","lab"]
});
